import * as React from 'react'

import { type MediumIcon } from '@factorialco/deprecated-design-system'

import {
  BaseRequestItem,
  RequestComponentProps,
} from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'

import CollapseContent from './components/CollapseContent'

const PendingQuestionGroupEnps = ({
  request,
  index,
  compact,
  removeRequestById,
}: RequestComponentProps) => {
  return (
    <>
      <BaseRequestItem
        icon={request.icon as MediumIcon}
        request={request}
        url={String(request.actionUrl)}
        index={index}
        compact={compact}
        collapseContent={
          <CollapseContent request={request} removeRequestById={removeRequestById} />
        }
      />
    </>
  )
}

export default PendingQuestionGroupEnps
